import ClosedRegForm from './ClosedRegForm';

export default ClosedRegForm;